import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { SelectTheme } from "../../components/SelectTheme";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import axios from "axios";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleResetBtn = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setErrors([]);
      await axios.post(`${BaseUrlApi}/forgot-password`, {
        email,
      });
      toast("تم إرسال الرمز", {
        description: "تحقق من بريدك الإلكتروني للحصول على رمز التحقق.",
      });
      navigate(`/check-code?email=${email}`);
    } catch (error) {
      setErrors(ErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-background" dir="rtl">
      {/* Left Section */}
      <div className="relative hidden w-1/2 p-8 lg:block">
        <div className="h-full w-full overflow-hidden rounded-[40px] bg-gradient-to-b from-secondaryColor via-mainColor to-background text-white">
          <div className="flex h-full flex-col items-center justify-center px-8 text-center">
            <div className="mb-8">
              <h1 className="text-2xl font-semibold">فريق أساكيب</h1>
            </div>
            <h2 className="mb-6 text-4xl font-bold">استعادة كلمة المرور</h2>
            <p className="mb-12 text-lg">
              سنساعدك على إعادة تعيين كلمة المرور والعودة إلى العمل.
            </p>

            <div className="w-full max-w-sm space-y-4">
              <div className="rounded-lg bg-primary-foreground/10 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black">
                    ١
                  </span>
                  <span className="text-lg">أدخل بريدك الإلكتروني</span>
                </div>
              </div>
              <div className="rounded-lg bg-primary-foreground/5 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-foreground/20">
                    ٢
                  </span>
                  <span className="text-lg">التحقق بواسطة الرمز</span>
                </div>
              </div>
              <div className="rounded-lg bg-primary-foreground/5 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-foreground/20">
                    ٣
                  </span>
                  <span className="text-lg">إنشاء كلمة مرور جديدة</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex w-full items-center justify-center bg-background p-6 lg:w-1/2">
        <div className="w-full max-w-md rounded-[40px]">
          <div className="mx-auto max-w-sm">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-3xl font-bold text-foreground">
                نسيت كلمة المرور
              </h2>
              <SelectTheme />
            </div>
            <p className="mb-8 text-muted-foreground">
              أدخل عنوان بريدك الإلكتروني لتلقي رمز التحقق.
            </p>

            <form className="space-y-6" onSubmit={handleResetBtn}>
              <div className="space-y-2">
                <Input
                  className="h-12 text-right"
                  placeholder="أدخل بريدك الإلكتروني"
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors?.email || errors ? (
                  <p className="text-red-500 font-semibold text-sm text-center">
                    {Array.isArray(errors?.email) ? errors?.email[0] : errors}
                  </p>
                ) : null}
              </div>

              <Button className="h-12 w-full" disabled={loading}>
                {loading && (
                  <div className="animate-spin mb-px">
                    <Loader2 />
                  </div>
                )}
                إرسال الرمز
              </Button>

              <p className="text-center text-sm text-muted-foreground">
                تتذكر كلمة المرور؟{" "}
                <Link to="/login" className="text-primary hover:underline">
                  العودة إلى تسجيل الدخول
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
